'use strict';

app
  .constant('social.config', {
    providers: {
      google: {
        name: 'google',
        url: '/api/v1/auth/google',
        popupOptions: { width: 452, height: 633 }
      },
      facebook: {
        name: 'facebook',
        url: '/api/v1/auth/facebook',
        popupOptions: { width: 580, height: 400 }
      },
      linkedin: {
        name: 'linkedin',
        url: '/api/v1/auth/linkedin',
        popupOptions: { width: 527, height: 582 }
      }
    }
  })
  .provider('$social', ['social.config', function (config) {
    angular.forEach(Object.keys(config.providers), function (provider) {
      this[provider] = function (params) {
        return angular.extend(config.providers[provider], params);
      };
    }, this);

    var oauth = function (params) {
      config.providers[params.name] = config.providers[params.name] || {};
      angular.extend(config.providers[params.name], params);
    };


    this.oauth2 = function (params) {
      oauth(params);
      config.providers[params.name].type = '2.0';
    };

    this.$get = [
      'social.oauth',
      function (oauth) {
        var $social = {};
        $social.authenticate = function (name, userData) {
          return oauth.authenticate(name, false, userData);
        };
        return $social;
      }];

  }])
  .factory('social.oauth', [
    '$q',
    '$http',
    'social.config',
    'social.Oauth2',
    function ($q, $http, config, Oauth2) {
      var oauth = {};
      oauth.authenticate = function (name, redirect, userData) {
        var provider = new Oauth2();
        return provider.open(config.providers[name], userData || {});
      };
      return oauth;
    }])
  .factory('social.Oauth2', [
    '$q',
    '$http',
    '$window',
    'social.popup',
    'social.utils',
    'social.config',
    function ($q, $http, $window, popup) {
      return function () {
        var defaults = {
          url: null,
          name: null,
          redirectUri: null,
          popupOptions: null
        };
        var oauth2 = {};
        oauth2.open = function (options) {
          angular.extend(defaults, options);
          var url = defaults.url;
          defaults.redirectUri = window.location.origin || window.location.protocol + '//' + window.location.host;
          return popup.open(url, defaults.popupOptions, defaults.redirectUri);
        };
        return oauth2;
      };
    }])
  .factory('social.popup', [
    '$q',
    '$interval',
    '$window',
    '$location',
    'social.config',
    'social.utils',
    '$log',
    function ($q, $interval, $window, $location, config, utils, $log) {
      var AUTH_RESULT_KEY = 'auth_result';
      var popupWindow = null;
      var popup = {};
      var polling;
      var deferred;
      popup.popupWindow = popupWindow;

      angular.element($window).on('storage', function listener (e) {

        if (e.key === AUTH_RESULT_KEY && e.newValue) {
          popupWindow.close();
          var result = getFromLocalStorage();
          $log.info('onstorage', result);
          if (result) {
            if (result.error) {
              deferred.reject({ error: result.error });
            } else {
              deferred.resolve(result);
            }
          }
        }
      });

      popup.open = function (url, options/*, redirectUri*/) {
        deferred = $q.defer();
        $interval.cancel(polling);
        var optionsString = popup.stringifyOptions(popup.prepareOptions(options || {}));
        popupWindow = window.open(url, '_blank', optionsString);
        if (popupWindow && popupWindow.focus) {
          popupWindow.focus();
        }
        if (!popupWindow) {
          deferred.reject({data: 'Provider Popup Blocked'});
          return deferred.promise;
        }
        polling = $interval(function () {
          if (!popupWindow || popupWindow.closed) {
            $log.info('Social window closed');
            deferred.resolve();
            $interval.cancel(polling);
          }
        }, 1000);
        return deferred.promise;
      };


      function getFromLocalStorage () {
        var authResponse = $window.localStorage.getItem(AUTH_RESULT_KEY);
        $window.localStorage.removeItem(AUTH_RESULT_KEY);
        $log.info('getFromLocalStorage', authResponse);
        return authResponse ? utils.parseURL(authResponse) : false;
      }

      popup.prepareOptions = function (options) {
        var width = options.width || 500;
        var height = options.height || 500;
        return angular.extend({
          width: width,
          height: height,
          left: $window.screenX + (($window.outerWidth - width) / 2),
          top: $window.screenY + (($window.outerHeight - height) / 2.5)
        }, options);
      };

      popup.stringifyOptions = function (options) {
        var parts = [];
        angular.forEach(options, function (value, key) {
          parts.push(key + '=' + value);
        });
        return parts.join(',');
      };

      return popup;
    }])
  .service('social.utils', function () {
    this.parseURL = function (url) {
      var parser = document.createElement('a');
      parser.href = url;
      var queryParams = parser.search.substring(1).replace(/\/$/, '');
      var hashParams = parser.hash.replace('_=_', '').substring(1).replace(/\/$/, '');
      var hash = this.parseQueryString(hashParams);
      var qs = this.parseQueryString(queryParams);
      angular.extend(qs, hash);
      return qs;
    };
    this.parseQueryString = function (keyValue) {
      var obj = {};
      var key;
      var value;
      angular.forEach((keyValue || '').split('&'), function (keyValue) {
        if (keyValue) {
          value = keyValue.split('=');
          key = decodeURIComponent(value[0]);
          obj[key] = angular.isDefined(value[1]) ? decodeURIComponent(value[1]) : true;
        }
      });
      return obj;
    };
  });
